import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getApproversPaginated = ({ churchId, page, pageSize }) => {
  return axios.get(
    `/churches/${churchId}/approvers-paginated?page=${page}&per_page=${pageSize}`
  );
};

export const useApproversPaginated = ({
  churchId,
  page,
  pageSize,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["approvers", churchId, page, pageSize],
    queryFn: () => getApproversPaginated({ churchId, page, pageSize })
  });
};
